<template>
  <div class="user-detail-layout">
    <div>
      <a-card :bordered="false">
        <a-row type="flex">
          <a-col :span="12">
            <div class="detail-status">
              <h4 style="font-weight: 700;">{{$t("descriptions.accountStatus")}}</h4>
              <div>
                {{$t('form.userDetail.accountStatus.account')}}：
                <span>{{accountInfo.phone}}</span>
              </div>
              <div>
                {{$t('table.common.thead.createTime')}}：
                <span>{{accountInfo.create_time}}</span>
              </div>
                 <div>
                {{$t('form.userDetail.accountStatus.edition')}}：
                <span>{{accountInfo.expire_time}}</span>
                {{$t('form.userDetail.accountStatus.expire')}}
              </div>
              <a-button
                v-if="siteInfo.member_renew==1"
                type="primary"
                @click="renewVisible=true"
              >{{$t("actionTitles.renew")}}</a-button>
            </div>
          </a-col>
          <a-col :span="12">
            <a-row type="flex" align="middle" justify="center">
              <div class="detail-capacity" style="width:253px;">
                <h5>{{$t("descriptions.totalSpaceCapacity")}}</h5>
                <div class="detail-capacity-icon">
                  <a-progress :percent="accountInfo.progress" :show-info="false" />
                  <a
                    class="detail-capacity-increase"
                    @click="addCapacity"
                  >{{$t('form.userDetail.spaceCapacity.increaseCapacity')}}</a>
                </div>
                <div class="detail-capacity-count">
                  <span>{{accountInfo.g_use_capacity}}G/{{accountInfo.g_capacity}}G</span>
                </div>
              </div>
            </a-row>
          </a-col>
        </a-row>
      </a-card>
    </div>

    <div style="margin-top:20px" class="user-detail-info">
      <a-card :title="$t(`moduleTitles.${$route.meta.title}`)" :bordered="false">
        <a-row>
          <a-col :span="12">
            <a-form-model
              layout="vertical"
              ref="ruleForm"
              :form="form"
              :rules="rules"
              :model="form"
            >
              <a-form-model-item
                has-feedback
                :label="$t('form.common.field.account.label')+'：'"
                prop="phone"
              >
                <a-input v-model="form.phone" :disabled="true" />
              </a-form-model-item>
              <a-form-model-item
                has-feedback
               :label="$t('form.common.field.name.label')+'：'"
                prop="name"
              >
                <a-input v-model="form.name" />
              </a-form-model-item>
              <a-form-model-item has-feedback :label="$t('form.common.field.gender.label')+'：'">
                <a-radio-group v-model="form.gender">
                  <a-radio :value="1">{{$t('enum.gender.male')}}</a-radio>
                  <a-radio :value="0">{{$t('enum.gender.female')}}</a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item has-feedback :label="$t('form.common.field.area.label')+'：'">
                <h-region-select @regionData="selectedData" :defaultValue="defaultValue"></h-region-select>
              </a-form-model-item>

              <a-form-model-item has-feedback :label="$t('form.common.field.address.label')+'：'">
                <a-textarea
                  v-model="form.address"
                  :placeholder="$t('form.common.field.address.message')"
                  allow-clear
                />
              </a-form-model-item>

              <a-form-model-item has-feedback :label="$t('form.common.field.mobile.label')+'：'">
                <a-input v-model="form.tel" :placeholder="$t('form.common.field.mobile.message')" />
              </a-form-model-item>

              <a-form-model-item>
                <a-button type="primary" @click="handleSubmit">{{$t('actionTitles.submit')}}</a-button>
                <a-button style="margin-left: 10px;">{{$t('actionTitles.cancel')}}</a-button>
              </a-form-model-item>
            </a-form-model>
          </a-col>
          <a-col :span="12">
            <div style="text-align: center;">
              <div class="avatar">
                <img
                  :src="form.avatar?form.avatar:avatar"
                  width="100%"
                  height="100%"
                  alt="avatar"
                />
              </div>
              <DragUploader ref="uploader" uptype="avatar" :callback="getUploader">
                <a-button type="primary" slot="body">{{$t('actionTitles.avatarUpload')}}</a-button>
              </DragUploader>
            </div>
          </a-col>
        </a-row>
      </a-card>
    </div>
    <pay-model :userId="userId" :visible="renewVisible" @close="renewVisible = false"></pay-model>
    <storage-pay-model :userId="userId" :visible="storageVisible" @close="storageVisible = false"></storage-pay-model>
  </div>
</template>
<script>
import HRegionSelect from "@/components/HRegionSelect";
import { getUserInfo, updateUserInfo } from "@/api/user";
import DragUploader from "@/components/DragUploader";
import { mapState } from "vuex";
import PayModel from "@/components/PayModel";
import StoragePayModel from "@/components/StoragePayModel";
import { validatephone } from "@/utils/validate";

export default {
  components: {
    HRegionSelect,
    DragUploader,
    PayModel,
    StoragePayModel,
  },
  computed: {
    ...mapState({
      siteInfo: (state) => state.siteConfig.siteInfo,
    }),
  },
  data() {
    let phoneCheck = (rule, value, callbackFn) => {
      // const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!validatephone(value)) {
        callbackFn(this.$t("form.common.field.phone.checkMessage"));
        return;
      }
      callbackFn();
    };
    return {
      headers: {
        authorization: "authorization-text",
      },
      form: {
        phone: "",
        gender: "male",
      },
      avatar: '/ssr/static/images/default_avatar.jpg',
      defaultValue: [],
      rules: {
        // phone: [
        //   {
        //     required: true,
        //     message: this.$t("form.common.field.phone.message"),
        //     trigger: "blur",
        //   },
        //   { validator: phoneCheck, trigger: "blur" },
        // ],
        name: [
          {
            required: true,
            message: this.$t("form.common.field.name.message"),
            trigger: "blur",
          },
        ],
      },
      uploadType: "normal",
      UpModelVisible: false,
      accountInfo: {},
      renewVisible: false,
      userId: 0,
      storageVisible: false,
    };
  },
  mounted() {
    //根據當前帳號查詢詳情
    getUserInfo().then((res) => {
      if (res.code) {
        this.form = res.data;
        this.accountInfo = { ...res.data };
        this.userId = res.data.id;
        this.accountInfo.expire_time = this.accountInfo.expire_time.substring(
          0,
          11
        );
        this.accountInfo.create_time = this.accountInfo.create_time.substring(
          0,
          11
        );
        this.defaultValue = res.data.parent_regoin;
      }
    });
  },
  methods: {
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          updateUserInfo(this.form).then((res) => {
            this.$message.success(this.$i18n.t("message.saveSuccess"));
            this.$store.dispatch("getUserInfo", this.form);
          });
        }
      });
    },
    handleSelectChange() {},
    handleCascaderChange() {},
    onSubmit() {
      console.log(this.form);
    },
    selectedData(val) {
      this.form.region = val;
    },
    addCapacity() {
      this.storageVisible = true;
    },
    //回調方法，up為上傳實例對像
    getUploader: function (up) {
      let _this = this;
      _this.$nextTick(() => {
        up.bind("UploadComplete", function (up, file) {
          _this.form.avatar = _this.$refs.uploader.fileList[0].url;
        });
      });
    },
  },
};
</script>

<style scoped>
.avatar {
  margin-bottom: 25px;
}
.avatar img {
  border-radius: 167px;
  width: 167px;
  height: 167px;
}
</style>
